import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

// Generic shell region (TK-077): an unnamed-purpose companion beside <main>,
// with the same standing as the main navigation. The shell knows nothing
// about what is projected into it.
@Component({
  selector: 'admin-shell',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss',
})
export class AdminShellComponent {
  @Input() open = false;
  @Input() accountHref: string | null = null;
  @Output() signOut = new EventEmitter<void>();

  @HostBinding('class.admin-shell--companion-open')
  get companionOpenClass(): boolean {
    return this.open;
  }

  onSignOut(): void {
    this.signOut.emit();
  }
}
